var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-180 32 32)",
    fill: "#FFEBA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0329 6.4V13.0009L17.5529 18.6942H14.4471L13.9671 13.0009V6.4H18.0329ZM16 20.5644C16.7341 20.5644 17.3176 20.757 17.7506 21.142C18.1835 21.5271 18.4 22.0405 18.4 22.6822C18.4 23.3423 18.1835 23.8649 17.7506 24.2499C17.3176 24.6166 16.7341 24.8 16 24.8C15.2659 24.8 14.6824 24.6166 14.2494 24.2499C13.8165 23.8649 13.6 23.3423 13.6 22.6822C13.6 22.0405 13.8165 21.5271 14.2494 21.142C14.6824 20.757 15.2659 20.5644 16 20.5644Z",
    fill: "#CCA418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFlag);
export default __webpack_public_path__ + "static/media/yellow-flag.94524cdf4b78ce61f5b8140cc0893e3d.svg";
export { ForwardRef as ReactComponent };